import type { ActionNodeData } from "../types"

export function getActionDisplayName(action: ActionNodeData): string {
  if (action.nodeKey !== "action__ai_research") return action.label

  const stepName = action.fields?.step_name
  return typeof stepName === "string" && stepName.trim() ? stepName.trim() : action.label
}
